import BaseReportPDFSettingsPreview from "../../BaseReportPDFSettingsPreview";
import LeavesReportStore from '../LeavesReportStore'

export default class  LeavesReportPDFSettingsPreview extends BaseReportPDFSettingsPreview {
    constructor($containerEl, lightboxId, eventNamespace) {
        super($containerEl, lightboxId);
        this.eventNamespace = eventNamespace;
    }

    getStore() {
        return LeavesReportStore;
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/leavesReport/pdfPreview/PDFSettingsPreview.js